module.exports = __webpack_public_path__ + "img/tunaylogo.b2387a81.png";